import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'classeAmericaine'
})
export class ClasseAmericainePipe implements PipeTransform {

  transform(motAVerifier:string){
    if(motAVerifier == 'Quiche Lorraine') {
      return 'Ouiche Lorraine';
    } else {
      return motAVerifier;
    }
  
  }

}
